import Vue from 'vue'
import Vuex from "vuex"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    store_type: 3,
    admin: {
      head_img: '',
      id: null,
      is_manager: 0,
      is_private: 0,
      locked: 0,
      nick_name: '智慧健康',
      phone: '',
      staff_type: 0,
      store_id: '',
      uname: '',
    },
    apply_info: {
      id: 0,
      store_id: 0,
      apply_name: '智慧健康',
      apply_logo: '',
      expire_time: '',
      status: 0,
    },
    menu:[],
    menuItem:[],
    routeItem:[],
    menuId:0,
    menuSonId: 0,
    Indent:false,
    cachedViews: [],
    isRefresh: false,
  },
  mutations: {
    update_type(state, res) {
      state.store_type = res;
    },
    update_admin(state, res) {
      state.admin = res;
    },
    ADD_TAG: (state, res) => {
      if (state.routeItem.some(v => v.path == res.path)) return false;
      state.routeItem.push({
        title: res.title,
        path: res.path
      })
    },
    DEL_TAG: (state, res) => {
      for (let [i, v] of state.routeItem.entries()) {
        if (v.path == res.path) {
          state.routeItem.splice(i, 1);
          break
        }
      }
    },
    DEL_ALL_TAG: (state) => {
      state.routeItem = [];
    },
    SET_APPLY_INFO: (state, res) => {
      state.apply_info = res
    },
    SET_MENU:(state,res)=>{
      state.menu = res
    },
    SET_MENU_ITEM:(state,res)=>{
      state.menuItem = res
    },
    SET_MENU_ID:(state,res)=>{
      state.menuId = res
    },
    SET_MENU_SHOW:(state,res)=>{
      state.Indent = res
    },
    SET_MENU_SON_ID:(state,res)=>{
      state.menuSonId = res
    },
    ADD_CACHED_VIEW: (state, viewName) => {
      if (!state.cachedViews.includes(viewName)) {
        state.cachedViews.push(viewName)
      }
    },
    DEL_CACHED_VIEW: (state, viewName) => {
      const index = state.cachedViews.indexOf(viewName)
      if (index > -1) {
        state.cachedViews.splice(index, 1)
      }
    },
    setIsRefresh(state, res) {
      state.isRefresh = res
    },
  },
  actions: {
    addTag({commit}, res) {
      commit('ADD_TAG', res)
    },
    delTag({commit, state}, res) {
      return new Promise((resolve) => {
        commit('DEL_TAG', res);
        resolve([...state.routeItem])
      })
    },
    setAdmin({commit}, res) {
      commit('update_admin', res)
    },
    setApplyInfo({commit}, res) {
      commit('SET_APPLY_INFO', res)
    },
    updateType({commit},res){
      commit('update_type',res)
    },
    setMenu({commit}, res) {
      commit('SET_MENU', res)
    },
    setMenuItem({commit}, res) {
      commit('SET_MENU_ITEM', res)
    },
    setMenuId({commit}, res) {
      commit('SET_MENU_ID', res)
    },
    setMenuSHOW({commit}, res) {
      commit('SET_MENU_SHOW', res)
    },
    setMenuSonId({commit}, res) {
      commit('SET_MENU_SON_ID', res)
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js